/** 添加事件 */
export function addEventListener(element, type, handler) {
    //ele 元素
    //type 事件类型
    //handler 处理事件的函数程序
    if (element.addEventListener) {
        element.addEventListener(type, handler, false);
    }
    else if (element.attachEvent) {
        element.attachEvent('on' + type, handler);
    }
    else {
        element['on' + type] = handler;
    }
}
/** 删除事件 */
export function removeEventListener(element, type, handler) {
    if (element.removeEventListener) {
        element.removeEventListener(type, handler, false);
    }
    else if (element.detachEvent) {
        element.detachEvent('on' + type, handler);
    }
    else {
        element['on' + type] = null;
    }
}
/** 兼容event */
export function getEvent(event) {
    return event ? event : window.event;
}
/** 获取事件目标 */
export function getElement(event) {
    return event.target || event.srcElement;
}
/** 阻止事件冒泡 */
export function preventDefault(event) {
    if (event.preventDefault) {
        event.preventDefault();
    }
    else {
        event.returnValue = false;
    }
}
/** 阻止事件的默认行为 */
export function stopPropagation(event) {
    if (event.stopPropagation) {
        event.stopPropagation();
    }
    else {
        event.cancleBubble = true;
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-event/index.js
// module id = 2377
// module chunks = 0